<div class="equipes">
  <div class="container">
    <div class="content-wrapper">
      <h2 class="titulo">Equipes</h2>
      <hr>
      <div *ngFor="let equipe of equipes" class="secao-equipe">
        <div class="cabecalho-equipe">
          <h3 class="titulo-equipe">{{ equipe.titulo }}</h3>
          <p class="subtitulo-equipe" *ngIf="equipe.subtitulo">{{ equipe.subtitulo }}</p>
        </div>
        <div class="grid-membros">
          <div
            *ngFor="let membro of equipe.membros"
            class="membro"
            [ngClass]="{
              'col-full': equipe.membros.length === 1,
              'col-half': equipe.membros.length === 2,
              'col-quarter': equipe.membros.length >= 3
            }"
          >
            <div class="nome-membro">{{ membro.nome }}</div>
            <div class="info-membro" *ngIf="membro.info">
              [{{ membro.info }}]
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
